export const APP_LOADED = 'APP_LOADED';
export const SET_APP_HEALTH = 'SET_APP_HEALTH';
export const SET_HEALTH_LAST_CHECKED = 'SET_HEALTH_LAST_CHECKED';
export const SET_UNSAVED_CHANGES = 'SET_HAS_UNSAVED_CHANGES';
